import { render } from "./DownloadAndWatch.vue?vue&type=template&id=4d8150fe&scoped=true"
import script from "./DownloadAndWatch.vue?vue&type=script&lang=js"
export * from "./DownloadAndWatch.vue?vue&type=script&lang=js"

import "./DownloadAndWatch.vue?vue&type=style&index=0&id=4d8150fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8150fe"]])

export default __exports__